/* eslint-disable react/jsx-key */

import React, { useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  TableContainer,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import "./Table.css";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    color: theme.palette.common.black,
  },

  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontWeight: "bold",
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(even)": {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function TableTransitions(props) {
  const [open, setOpen] = useState(props.open);
  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  const onChange = () => {
    setOpen(!open);
  };
  return (
    <div>
      <Accordion
        onChange={onChange}
        expanded={open}
        style={{
          backgroundColor: "#3d3d3d",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          // height: "2em",
          // display: "flex",
          // alignItems: "center",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon htmlColor="white" />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <div>
            <Typography style={{ color: "white" }}>
              {props.titleTable} {props.title}
            </Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails className="content-response">
          <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
            <Table sx={{ minWidth: 600 }} aria-label="customized table">
              <TableHead>
                <TableRow style={{ backgroundColor: "rgba(0,0,0,0.25)" }}>
                  {props.alphabet.map((row, index) => (
                    <StyledTableCell key={index} scope="row">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {row}
                      </div>
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(props.rows).map((row, index) => (
                  <StyledTableRow key={index}>
                    {props.rows[row].map((states) => (
                      <StyledTableCell component="th" scope="row">
                        <div className="container-cell">
                          <div>
                            {states.initial != undefined ? (
                              <div className="container-initial">
                                <div className="initial"></div>
                                <div className="state"></div>
                              </div>
                            ) : (
                              <div
                                className="container-initial"
                                style={{ visibility: "hidden" }}
                              >
                                <div className="initial"></div>
                                <div className="state"></div>
                              </div>
                            )}
                          </div>

                          <div className="container-final">
                            {states.final != undefined ? (
                              <div className="state">
                                <div></div>
                              </div>
                            ) : null}
                          </div>
                          {states.actual != undefined && states.actual == true && (
                            <div className="container-actual">
                              <div className="actual-state"></div>
                            </div>
                          )}
                          {/* Células de informação das transições da tabela */}
                          <div
                            style={{
                              width: "100%",
                              color:
                                states.color != undefined
                                  ? states.color
                                  : "black",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {/* {console.log(states)} */}
                            {states.name != undefined ? states.name : states}
                          </div>
                        </div>
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
